/** Design System switch. Everything of the MMEC Design System is scoped to `html[data-mmec-ds="1"]`; this module
 *  sets that attribute before React mounts (no flash of the old palette). Default ON for everyone; `?ds=0` opts out. */
export function isDesignSystemOn(): boolean {
  try {
    return document.documentElement.getAttribute("data-mmec-ds") === "1";
  } catch {
    return false;
  }
}

function turnOn(): void {
  document.documentElement.setAttribute("data-mmec-ds", "1");
  if (!document.getElementById("mmec-ds-fonts")) {
    const l = document.createElement("link");
    l.id = "mmec-ds-fonts";
    l.rel = "stylesheet";
    l.href = "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=JetBrains+Mono:wght@400;600;700&family=IBM+Plex+Sans+Arabic:wght@400;600;700&display=swap";
    document.head.appendChild(l);
  }
}

/** Since 2026-11-03 (owner: "make it the default for everyone") the Design System is ON for every browser.
 *  `?ds=0` opts one browser out (stored as localStorage mmec_ds = "0"); `?ds=1` clears the opt-out. */
export function applyDesignSystemPreview(): void {
  let off = false;
  try {
    const q = new URLSearchParams(window.location.search).get("ds");
    if (q === "0") localStorage.setItem("mmec_ds", "0");
    if (q === "1") localStorage.removeItem("mmec_ds");
    off = localStorage.getItem("mmec_ds") === "0";
  } catch {
    /* storage blocked: keep the default (on) */
  }
  try {
    if (off) document.documentElement.removeAttribute("data-mmec-ds");
    else turnOn();
  } catch {
    /* no document */
  }
}
